import script from "./honors.vue?vue&type=script&setup=true&lang=js"
export * from "./honors.vue?vue&type=script&setup=true&lang=js"

import "./honors.vue?vue&type=style&index=0&id=54c8046c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54c8046c"]])

export default __exports__